import script from "./MfgCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MfgCard.vue?vue&type=script&setup=true&lang=js"

import "./MfgCard.vue?vue&type=style&index=0&id=65599167&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65599167"]])

export default __exports__